// COPIED from global website
// Please attempt to keep the two in sycn
// Untill/unless we find a way to share / package the reused functionality

import ISite from "../interfaces/ISite";

export interface OpenTime {
    dayName: string;
    dayIndex: number; //As per javascript day number indexing sunday as 0
    openingHours: string;
    openTime: string;
    closeTime: string;
}

export const formatOpenTimeString = (openTime: string): string => {
    if (!openTime) return "Not available"

    // Split the time string into hours and minutes
    const [hourStr, minuteStr] = openTime.split(':');
    const hours = parseInt(hourStr, 10);
    const minutes = parseInt(minuteStr, 10);

    // Determine AM or PM suffix
    const suffix = hours >= 12 ? 'PM' : 'AM';

    // Convert hour from 24-hour to 12-hour format
    const hourIn12HourFormat = hours % 12 || 12; // Transform "0" hour to "12"

    // Format minutes to ensure two digits
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

    // Construct the final formatted time string
    return `${hourIn12HourFormat}:${formattedMinutes} ${suffix}`;
}

export const createOpenTimesList = (siteDetails: ISite): OpenTime[] => {
    return [
        {
            dayName: "Sunday",
            dayIndex: 0,
            openingHours: siteDetails?.siteMetadata?.sundayOpeningHours,
            openTime: formatOpenTimeString(siteDetails?.siteMetadata?.sundayOpenTime),
            closeTime: formatOpenTimeString(siteDetails?.siteMetadata?.sundayCloseTime)
        },
        {
            dayName: "Monday",
            dayIndex: 1,
            openingHours: siteDetails?.siteMetadata?.mondayOpeningHours,
            openTime: formatOpenTimeString(siteDetails?.siteMetadata?.mondayOpenTime),
            closeTime: formatOpenTimeString(siteDetails?.siteMetadata?.mondayCloseTime)
        },
        {
            dayName: "Tuesday",
            dayIndex: 2,
            openingHours: siteDetails?.siteMetadata?.tuesdayOpeningHours,
            openTime: formatOpenTimeString(siteDetails?.siteMetadata?.tuesdayOpenTime),
            closeTime: formatOpenTimeString(siteDetails?.siteMetadata?.tuesdayCloseTime)
        },
        {
            dayName: "Wednesday",
            dayIndex: 3,
            openingHours: siteDetails?.siteMetadata?.wednesdayOpeningHours,
            openTime: formatOpenTimeString(siteDetails?.siteMetadata?.wednesdayOpenTime),
            closeTime: formatOpenTimeString(siteDetails?.siteMetadata?.wednesdayCloseTime)
        },
        {
            dayName: "Thursday",
            dayIndex: 4,
            openingHours: siteDetails?.siteMetadata?.thursdayOpeningHours,
            openTime: formatOpenTimeString(siteDetails?.siteMetadata?.thursdayOpenTime),
            closeTime: formatOpenTimeString(siteDetails?.siteMetadata?.thursdayCloseTime)
        },
        {
            dayName: "Friday",
            dayIndex: 5,
            openingHours: siteDetails?.siteMetadata?.fridayOpeningHours,
            openTime: formatOpenTimeString(siteDetails?.siteMetadata?.fridayOpenTime),
            closeTime: formatOpenTimeString(siteDetails?.siteMetadata?.fridayCloseTime)
        },
        {
            dayName: "Saturday",
            dayIndex: 6,
            openingHours: siteDetails?.siteMetadata?.saturdayOpeningHours,
            openTime: formatOpenTimeString(siteDetails?.siteMetadata?.saturdayOpenTime),
            closeTime: formatOpenTimeString(siteDetails?.siteMetadata?.saturdayCloseTime)
        }

    ];
}

//export const formatAddress = (siteDetails: ISite): string => {
//    if (siteDetails.streetAddress) {
//        return siteDetails.streetAddress;
//    }

//    // Creating the address string
//    const addressParts: string[] = [];
//    if (siteDetails.addressLine1) addressParts.push(siteDetails.addressLine1);
//    if (siteDetails.addressLine2) addressParts.push(siteDetails.addressLine2);
//    if (siteDetails.state) addressParts.push(siteDetails.state);
//    if (siteDetails.postCode) addressParts.push(siteDetails.postCode);

//    // Joining the parts with a comma and space, excluding empty parts
//    const formattedAddress = addressParts.join(', ');

//    return formattedAddress;
//}

export const getCurrentDay = (siteDetails: ISite | undefined): string => {

    if (siteDetails === undefined) {
        return '';
    }

    const currentDate = new Date();
    const dayNumber = currentDate.getDay();

    switch (dayNumber) {
        case 0:
            return siteDetails?.siteMetadata?.sundayOpeningHours ? siteDetails?.siteMetadata?.sundayOpeningHours : `${formatOpenTimeString(siteDetails?.siteMetadata?.sundayOpenTime)} - ${formatOpenTimeString(siteDetails?.siteMetadata?.sundayCloseTime)} `
        case 1:
            return siteDetails?.siteMetadata?.mondayOpeningHours ? siteDetails?.siteMetadata?.mondayOpeningHours : `${formatOpenTimeString(siteDetails?.siteMetadata?.mondayOpenTime)} - ${formatOpenTimeString(siteDetails?.siteMetadata?.mondayCloseTime)} `
        case 2:
            return siteDetails?.siteMetadata?.tuesdayOpeningHours ? siteDetails?.siteMetadata?.tuesdayOpeningHours : `${formatOpenTimeString(siteDetails?.siteMetadata?.tuesdayOpenTime)} - ${formatOpenTimeString(siteDetails?.siteMetadata?.tuesdayCloseTime)} `
        case 3:
            return siteDetails?.siteMetadata?.wednesdayOpeningHours ? siteDetails?.siteMetadata?.wednesdayOpeningHours : `${formatOpenTimeString(siteDetails?.siteMetadata?.wednesdayOpenTime)} - ${formatOpenTimeString(siteDetails?.siteMetadata?.wednesdayCloseTime)} `
        case 4:
            return siteDetails?.siteMetadata?.thursdayOpeningHours ? siteDetails?.siteMetadata?.thursdayOpeningHours : `${formatOpenTimeString(siteDetails?.siteMetadata?.thursdayOpenTime)} - ${formatOpenTimeString(siteDetails?.siteMetadata?.thursdayCloseTime)} `
        case 5:
            return siteDetails?.siteMetadata?.fridayOpeningHours ? siteDetails?.siteMetadata?.fridayOpeningHours : `${formatOpenTimeString(siteDetails?.siteMetadata?.fridayOpenTime)} - ${formatOpenTimeString(siteDetails?.siteMetadata?.fridayCloseTime)} `
        case 6:
            return siteDetails?.siteMetadata?.saturdayOpeningHours ? siteDetails?.siteMetadata?.saturdayOpeningHours : `${formatOpenTimeString(siteDetails?.siteMetadata?.saturdayOpenTime)} - ${formatOpenTimeString(siteDetails?.siteMetadata?.saturdayCloseTime)} `
        default:
            return "Not available"
    }
}